export default {
  name: '',
  description: '',
  domain: '',
  permissions: [],
};
